<!-- <ion-button
  aria-label="Learn More About Connectivity"
  *ngIf="network && !mute"
  (click)="learnMoreConnectivity()"
  id="network-button"
  [tooltip]="network.label">
  <ion-icon [src]="network.icon" [color]="network.color" slot="icon-only"> </ion-icon>
  <span class="sr-only"> Network Connection Strength is {{ network.quality }} of 5 </span>
</ion-button> -->
<div class="mini-notifications">
  <sc-mini-notification
    @fadeInOut
    *ngFor="let n of notifications; trackBy: trackByID"
    [icon]="n.icon ? '/assets/icons/24px/' + n.icon : null"
    [color]="n.color"
    (click)="dismissNotification(n)"
    [topic]="n.topic"
    >{{ n.label }}</sc-mini-notification
  >
</div>
<div class="top-right-buttons">
  <ion-button
    *ngIf="session$?.value?.confType !== 'daily'"
    aria-label="Show Stats"
    (click)="toggleStats(dailyParticipant.userData.scUID)"
    id="stats-button"
    tooltip="Show Stats">
    <ion-icon src="/assets/icons/24px/nerd.svg" slot="icon-only"> </ion-icon>
  </ion-button>

  <ion-button
    *ngIf="isLocalParticipant && !isScreenShare"
    (click)="minimizeParticipant()"
    id="hide-self-button"
    aria-label="Hide Yourself locally"
    tooltip="Hide Yourself">
    <ion-icon src="/assets/icons/24px/hide-self.svg" slot="icon-only"> </ion-icon>
  </ion-button>

  <ion-button
    aria-label="Toggle containing full video frame locally"
    *ngIf="!isScreenShare"
    (click)="toggleObjectFitCover()"
    id="object-fit-button"
    tooltip="Contain Video">
    <ion-icon src="/assets/icons/24px/distance-from-microphone-3.svg" slot="icon-only"> </ion-icon>
  </ion-button>

  <ion-button aria-label="Pin to my Screen" (click)="pinParticipant()" id="pin-button" tooltip="Pin to My Screen">
    <ion-icon src="/assets/icons/16px/pin-active.svg" slot="icon-only"> </ion-icon>
  </ion-button>
</div>

<ion-chip *ngIf="width <= 300" class="name minimized" (click)="openEquipmentPopover($event)">
  <span id="first-letter">
    {{ name?.charAt(0) }}
  </span>
  <span id="full-name">{{ name?.slice(1) }} {{ isScreenShare ? 'Screen' : '' }}</span>
</ion-chip>

<ion-chip *ngIf="width > 300" class="name" (click)="openEquipmentPopover($event)">
  <span>{{ name }} {{ isScreenShare ? 'Screen' : '' }}</span>
</ion-chip>

<sc-player
  (width)="widthChanged($event)"
  [mediaStream]="dailyParticipant?.activeStream"
  [dailyParticipant]="dailyParticipant"
  [placeholderName]="name"
  [mirrored]="isLocalParticipant && !isScreenShare"
  [muted]="mute"
  [videoOff]="videoOff"
  [isLocalParticipant]="isLocalParticipant"
  [isScreenShare]="isScreenShare"></sc-player>
